import moment from 'moment'

import { getContractorName } from '../helpers'
import { formatCurrency } from '@/utils/currencyHelpers'
import { Alert, Table, Text } from '@/ui'
import { DATE_FORMATS } from '@/utils/dateHelpers'
import {
  Gusto_Contractor,
  Gusto_ContractorPayment,
} from '../generated_gusto_types'
import { TypographyStyles } from '@/styles'

export const ContractorPaymentsTab = ({
  contractor,
  contractorPayments,
}: {
  contractor: Gusto_Contractor
  contractorPayments: Gusto_ContractorPayment[]
}) => (
  <div className="flex flex-col gap-6">
    <Text variant={TypographyStyles.BODY_MD}>
      This lists all payments you’ve made to {getContractorName(contractor)}
    </Text>

    {contractorPayments.length > 0 ? (
      <div className="overflow-x-auto">
        <Table>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell className="w-1/6">Pay Day</Table.HeaderCell>
              <Table.HeaderCell className="w-1/6">Hours</Table.HeaderCell>
              <Table.HeaderCell className="w-1/4">Wages</Table.HeaderCell>
              <Table.HeaderCell className="w-1/4">Bonus</Table.HeaderCell>
              <Table.HeaderCell className="w-1/4">
                Reimbursements
              </Table.HeaderCell>
              <Table.HeaderCell className="text-right w-1/4">
                Total
              </Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {contractorPayments.map((payment) => {
              const wages =
                Number(payment.wage) ||
                Number(payment.hourly_rate) * Number(payment.hours)
              const total =
                wages + Number(payment.bonus) + Number(payment.reimbursement)

              return (
                <Table.Row key={payment.uuid}>
                  <Table.Cell>
                    {moment(payment.date).format(DATE_FORMATS.DISPLAY_SHORT)}
                  </Table.Cell>
                  <Table.Cell>{payment.hours}</Table.Cell>
                  <Table.Cell>{formatCurrency(wages)}</Table.Cell>
                  <Table.Cell>{formatCurrency(payment.bonus)}</Table.Cell>
                  <Table.Cell>
                    {formatCurrency(payment.reimbursement)}
                  </Table.Cell>
                  <Table.Cell className="text-right">
                    <b>{formatCurrency(total)}</b>
                  </Table.Cell>
                </Table.Row>
              )
            })}
          </Table.Body>
        </Table>
      </div>
    ) : (
      <Alert title="Pay Stubs">
        All future contractor payment details will display here.
      </Alert>
    )}
  </div>
)
